import { createContext, useContext } from "react";

export type ToastKind = "success" | "error" | "info" | "loading";

export type ToastItem = {
  id: string;
  kind: ToastKind;
  message: string;
};

export type ToastApi = {
  success: (message: string, id?: string) => string;
  error: (message: string, id?: string) => string;
  info: (message: string, id?: string) => string;
  loading: (message: string, id?: string) => string;
  dismiss: (id: string) => void;
};

const ToastContext = createContext<ToastApi | null>(null);

export const ToastContextProvider = ToastContext.Provider;

export function useToast(): ToastApi {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error("useToast must be used within ToastProvider");
  return ctx;
}
